export default __webpack_public_path__ + "static/media/soundSystem.9f8f6c16.jpg";